import { type FC } from 'react';
import { Help, type HelpProps } from '@direct-frontend/components';

export const BadgeLabelHelp: FC<HelpProps> = (props) => (
    <Help maxWidth="360" {...props}>
        При изменении названия бейдж будет обновлен для всех товаров, на которых он активен.
    </Help>
);
